import { type PublicSku, PublicSkuSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { ApiError, apiFetch } from '../../../lib/api-client';
import { marketKeys } from '../market-keys';

export const useSku = (number: number) =>
  useQuery<PublicSku | null>({
    queryKey: marketKeys.sku(number),
    queryFn: async () => {
      try {
        return PublicSkuSchema.parse(await apiFetch<unknown>(`/market/skus/${number}`));
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) return null;
        throw err;
      }
    },
  });
